import { render } from "./ValeTransporte.vue?vue&type=template&id=7b45adc2"
import script from "./ValeTransporte.vue?vue&type=script&lang=js"
export * from "./ValeTransporte.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__